module.exports = __webpack_public_path__ + "static/assets/efdbd2bebd1a97c3092b338db4d119b5.png";